module.exports = __webpack_public_path__ + "static/img/Coding.ee97b4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Coding.png
// module id = 2235
// module chunks = 61